import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { Observable, Observer, Subscription } from 'rxjs';
import * as moment from 'moment';

/* User defined library/components */
import { BootstrapParams } from '../../../../../bootstrap-params';
import { SchedulingApiService } from '../../services/scheduling-api.service';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';
import { UtilityService } from '../../../../shared/services/utility.service';
import { TranslateService } from '@ngx-translate/core';
import { TimerService } from '../../../../shared/services/timer.service';
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { Client } from '../../../../shared/models/scheduling/client.model';
import { Exam } from '../../../../shared/models/scheduling/exam.model';
import { Program } from '../../../../shared/models/scheduling/program.model';
import { Timezone } from '../../../../shared/models/scheduling/timezone.model';
import { Hold } from '../../../../shared/models/scheduling/hold.model';
import { AppointmentSlot } from '../../../../shared/models/scheduling/appointmentSlot.model';
import { Eligibility, EligibilityDetail } from '../../../../shared/models/scheduling/eligibility.model';
import { Proctor } from '../../../../shared/models/scheduling/proctor.model';

@Component({
  selector: 'app-proctor-selector',
  templateUrl: './proctor-selector.component.html',
  styleUrls: ['./proctor-selector.component.scss']
})
/** proctor-selector component*/
export class ProctorSelectorComponent implements OnInit {
  public selectedStartDate: any;
  public selectedEndDate: any;
  public selectedSeat: any;
  public isCurrentFormChanged: Boolean;
  public IsHoldInProgress: Boolean;
  public showSelectedDate: boolean = false;
  public toggleCalendar: boolean = false;
  public startDateError: string = '';
  public endDateError: string = '';
  public selectedAppointments: AppointmentDetail[] = []
  public client: Client;
  public exam: Exam;
  public program: Program;
  public selectedIndex: number = 0;
  public endDisabled: boolean = true;
  public examName: string;
  public isBackToBackRequired: boolean = false;
  public firstTimeSearch: boolean;
  public results: boolean = false;
  public timezone: Timezone;
  public procs: Proctor[];
  public slotData: any = [];
  public holdSlotObj: Hold;
  public holdsObjects: any;
  public prevSelectedHoldObj: any = [];
  public prevSelectedHoldObjArr: any = [];
  public firstTimeLocationSearch: boolean[] = [];
  public examWithTA: Exam[] = [];
  public takeProctorsize: number;
  public skipSiteSlotsize: number;
  public eligibilityDetails: EligibilityDetail[] = [];
  public proctors: Proctor[] = [];
  public isMoreTimes: boolean = true;
  public proctorsSearched: boolean = false;
  public selectedProctor: Proctor;
  public popProctorSelector: any;
  public popoverEnabled: boolean = false;
  public appliedClass: string = "btn secNavAction"
  public disableSearch: boolean = false;
  public schedulingError: string = '';
  public overlapsDate: string;

  public today = new Date();

  public startDateOptions: kendo.ui.DatePickerOptions;
  public endDateOptions: kendo.ui.DatePickerOptions;

  public placeHolderText: string;

  /* Input-OutPut parameters decalartions */
  @Output() setPlaceHolder = new EventEmitter<any>();
  @Output() selectionMode = new EventEmitter<any>();
  @Output() error = new EventEmitter<any>();
  @Output() validRegionSelector = new EventEmitter<any>();
  @Output() slotsCheck: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectedSiteDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedTimezone: Timezone;
  @Input() SelectedStartDate: any;
  @Input() SelectedEndDate: any;
  @Input() targetFlow: string;

  /* Service subscriptions */
  hold$: Subscription;
  region$: Subscription;
  selectedLocation$: Subscription;
  selectedStartDate$: Subscription;
  selectedEndDate$: Subscription;
  selectedAppointments$: Subscription;
  client$: Subscription;
  program$: Subscription;
  exam$: Subscription;
  firstTimeSearch$: Subscription;
  overlapsDate$: Subscription;
  overLapStartDate: any;
  overLapStartDate$: Subscription;
  overLapEndDate: any;
  overLapEndDate$: Subscription;
  country$: Subscription;
  state$: Subscription;
  translateLanguage$: Subscription;
  timezone$: Subscription;
  skipSize$: Subscription;
  eligibilityDetails$: Subscription;
  slot$: Subscription;
  proctors$: Subscription;

  /** proctor-selector */
  constructor(private schedulingApiService: SchedulingApiService,
    private selectedExamDetailService: SelectedExamDetailService,
    private utilityService: UtilityService,
    private translate: TranslateService,
    private timerService: TimerService,
    private bootstrapParams: BootstrapParams
  ) {

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      }
    );

    this.client$ = selectedExamDetailService.client.subscribe(
      client => {
        this.client = client;
      });
    this.program$ = selectedExamDetailService.program.subscribe(program => {
      this.program = program;
    });

    this.selectedAppointments$ = selectedExamDetailService.selectedAppointmentDetails.subscribe(
      selectedAppointments => {
        this.selectedAppointments = selectedAppointments;
      });

    this.exam$ = selectedExamDetailService.exam.subscribe(exam => {
      this.exam = exam;
      if (exam == null || exam == undefined) {
        this.exam = (this.selectedAppointments && this.selectedAppointments.length) ? this.selectedAppointments[0].exam : null;
      }
    });

    this.hold$ = selectedExamDetailService.hold.subscribe(hold => {
      this.holdSlotObj = hold;
    });

    this.overlapsDate$ = selectedExamDetailService.overlapsDate.subscribe(
      overlapsDate => {
        this.overlapsDate = overlapsDate;
      });

    this.overLapStartDate$ = selectedExamDetailService.overlapsFromDate.subscribe(
      startDate => {
        this.overLapStartDate = startDate;
      });

    this.overLapEndDate$ = selectedExamDetailService.overlapsToDate.subscribe(
      endDate => {
        this.overLapEndDate = endDate;
      });

    this.selectedStartDate$ = selectedExamDetailService.selectedStartDate.subscribe(selectedStartDate => {
      this.selectedStartDate = selectedStartDate;
    });

    this.selectedEndDate$ = selectedExamDetailService.selectedEndDate.subscribe(selectedEndDate => {
      this.selectedEndDate = selectedEndDate;
    });

    this.selectedIndex = this.selectedExamDetailService.selectedAppointmentIndex;

    if (this.targetFlow == null || this.targetFlow == undefined)
      this.targetFlow = this.selectedExamDetailService.currentTargetFlow;

    if (this.selectedStartDate != null || this.selectedStartDate != undefined) {
      this.selectedExamDetailService.setSelectedStartDate(this.selectedStartDate);
      this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
    }

    this.firstTimeSearch$ = this.selectedExamDetailService.firstTimeSearch.subscribe(firstTimeSearch => {
      this.firstTimeSearch = firstTimeSearch;
    });

    this.timezone$ = this.selectedExamDetailService.timezone.subscribe(timezone => {
      if (timezone != null) {
        this.timezone = timezone;
      }
    });

    this.skipSize$ = selectedExamDetailService.skipSize.subscribe(
      skipSize => {
        this.skipSiteSlotsize = skipSize || 0;
      }
    );

    this.eligibilityDetails$ = selectedExamDetailService.eligibilityDetails.subscribe(value => {
      this.eligibilityDetails = value || [];
    });

    this.slot$ = selectedExamDetailService.slot.subscribe(slot => {
      this.selectedProctor = slot;
    });

    this.proctors$ = selectedExamDetailService.proctors.subscribe(proctors => {
      this.proctors = proctors;
      if (this.proctors !== null && this.proctors.length > 0) {
        this.proctorsSearched = true
      }
    });

    this.startDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidStart(),
      max: this.getValidStartDateEnd(),
      start: "month",
      disableDates: [this.today]
    };

    this.endDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      start: "month"
    };

    this.selectedTimezone = this.timezone;
    this.placeHolderText = this.selectedExamDetailService.dateFormat.toUpperCase();
  }

  ngOnInit(): void {
    this.examName = this.exam.name;
    this.isCurrentFormChanged = false;
    this.takeProctorsize = this.bootstrapParams.proctorTakeSize;

    sessionStorage.setItem('previousUrl', window.location.pathname);
    //if (!this.utilityService.isDataValidToLoadComponent(ComponentType.LocationSelectorComponent)) return;

    if (!this.selectedStartDate) {
      this.endDisabled = true;
      this.disableSearch = true;
    }
    if (this.selectedStartDate != null || this.selectedStartDate != undefined) {
      this.setSelectedStartDate(this.selectedStartDate);
    }

    if (this.selectedEndDate != null || this.selectedEndDate != undefined) {
      this.setSelectedEndDate(this.selectedEndDate);
    }

    this.startDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidStart(),
      max: this.getValidStartDateEnd(),
      start: "month",
      disableDates: [this.today]
    };

    if (this.selectedStartDate) {
      this.endDateOptions = {
        format: this.selectedExamDetailService.dateFormat,
        culture: this.selectedExamDetailService.browserCulture,
        min: this.getValidEndDateStart(),
        max: this.getValidEndDateEnd(),
        start: "month",
        disableDates: [this.today]
      };
    }

    this.IsHoldInProgress = false;

    this.selectedAppointments.forEach((appointment) => {

      let tempExamWithTA: any = { id: appointment.exam.id, testingAccommodations: appointment.exam.testingAccommodations }
      this.examWithTA.push(tempExamWithTA);
    });
  }

  public isDisable(): boolean {
    return (
      this.selectedStartDate == null
      || (this.endDateError != '')
      || (this.startDateError != '')
    );
  }

  /* Set Start date in shaered service */
  setSelectedStartDate(value: any): void {
    // disable the "Find available times" button if date is modified and not valid
    if (!value) this.disableSearch = true;

    const today = new Date();
    var year = value && value['date'] ? value['date']['year'] : new Date().getFullYear();
    var month = value && value['date'] ? value['date']['month'] : new Date().getMonth();
    var day = value && value['date'] ? value['date']['day'] : new Date().getDate();

    var currentDate = new Date(year, month - 1, day);
    currentDate.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0);
    if (currentDate && currentDate < today) this.startDateError = "Start date must be a date in the future.";
    else if (currentDate && currentDate >= today) {
      this.startDateError = '';
      this.toggleCalendar = true;
      this.selectionMode.emit('end');
      this.selectedStartDate = value;
      this.selectedExamDetailService.setSelectedStartDate(this.selectedStartDate);
      this.endDisabled = false;


      if (!this.selectedEndDate) {
        this.endDateError = '';
        this.selectedEndDate = value;
        this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
        this.disableSearch = false;

      }
      if (this.selectedEndDate) {
        const start = new Date(value['date']['year'], value['date']['month'] - 1, value['date']['day']);
        const end = new Date(this.selectedEndDate['date']['year'],
          this.selectedEndDate['date']['month'] - 1,
          this.selectedEndDate['date']['day']);
        const endLimit = new Date(start);
        endLimit.setDate(start.getDate()/* + 14*/); // End date should always change with start date when single day range

        endLimit.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        this.disableSearch = false;

        //reset endDate
        if (end > endLimit || end < start) {
          this.endDateError = '';
          this.selectedEndDate = value;
          this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
          this.disableSearch = false;
        }
      }
    }
    this.error.emit({ endDateError: this.endDateError, startDateError: this.startDateError });

    this.endDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidEndDateStart(),
      max: this.getValidEndDateEnd(),
      start: "month",
      disableDates: [this.today]
    };
  }

  /* Set End date in shared service */
  setSelectedEndDate(value: any): void {
    // disable the "Find available times" button if date is modified and not valid
    if (!value) this.disableSearch = true;

    var year = value && value['date'] ? value['date']['year'] : new Date().getFullYear();
    var month = value && value['date'] ? value['date']['month'] : new Date().getMonth();
    var day = value && value['date'] ? value['date']['day'] : new Date().getDate();
    var currentDate = new Date(year, month - 1, day);

    const selectedStartDate =
      new Date(this.selectedStartDate['date']['year'], this.selectedStartDate['date']['month'] - 1, this.selectedStartDate['date']['day'])

    const endLimit = new Date(selectedStartDate);
    endLimit.setDate(selectedStartDate.getDate() + 15);

    endLimit.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0);
    selectedStartDate.setHours(0, 0, 0, 0);
    if (!currentDate)
      this.endDateError = 'You must select an end date that is within 2 weeks of the selected start date.';

    if (currentDate && (currentDate > endLimit || currentDate < selectedStartDate))
      this.endDateError = "You must select an end date that is within 2 weeks of the selected start date.";

    else if (currentDate && currentDate < endLimit && currentDate >= selectedStartDate) {
      this.endDateError = '';
      this.toggleCalendar = false;
      this.disableSearch = false;
      this.selectionMode.emit('start');
      this.selectedEndDate = value;
      this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
    }
    this.error.emit({ endDateError: this.endDateError, startDateError: this.startDateError });

    // commenting out now - to be done in next release
    //this.selectedExamDetailService.setProctors(null);
    //this.selectedExamDetailService.setSlot(null);
  }

  getValidStart(): Date {
    return this.utilityService.getValidStart(this.overLapStartDate);
  }

  getValidStartDateEnd(): Date {
    return this.utilityService.getValidStartDateEnd(this.overLapStartDate, this.overLapEndDate);
  }

  getValidEndDateEnd(): Date {
    return this.utilityService.getValidEndDateEnd(this.selectedStartDate['date'], this.overLapEndDate, 1); // Reduced search range to single day
  }

  getValidEndDateStart(): Date {
    const beginDate = this.selectedStartDate['date'];
    return this.utilityService.getValidEndDateStart(beginDate);
  }

  getAvailableTimes() {
    // Added timeout because of delay that can occur in datepicker sync before searching for proctors
    setTimeout(() => {
      this.resetCurrentSelection();
      this.takeProctorsize = this.bootstrapParams.proctorTakeSize;
      this.skipSiteSlotsize = 0;
      this.isMoreTimes = true;

      this.selectedExamDetailService.setTimeZone(this.selectedTimezone);

      this.getProctors().subscribe((proctors: Proctor[]) => {
        this.proctors = proctors;
        this.selectedExamDetailService.setProctors(proctors);
      });
    });
  }

  getProctors() {
    const startMonth = this.selectedStartDate['date']['month'] - 1;
    const startDay = this.selectedStartDate['date']['day'];
    const startYear = this.selectedStartDate['date']['year'];
    const endMonth = this.selectedEndDate['date']['month'] -1;
    const endDay = this.selectedEndDate['date']['day'];
    const endYear = this.selectedEndDate['date']['year'];
    let startDate = encodeURIComponent(moment([startYear, startMonth, startDay]).format('YYYY-MM-DDTHH:mm:ss'));
    let endDate = encodeURIComponent(moment([endYear, endMonth, endDay]).format('YYYY-MM-DDTHH:mm:ss'));
    let eligibilityId = this.eligibilityDetails ? this.eligibilityDetails[0] && this.eligibilityDetails[0].id : '-1';

    let takesize: number = this.takeProctorsize;
    let skipsize: number = this.skipSiteSlotsize;

    return new Observable((observer: Observer<any>) => {
      this.schedulingApiService.getProctors(startDate, endDate, eligibilityId, this.timezone.code, this.examWithTA, takesize, skipsize).subscribe(
        result => {
          let tests = result.itinerary;
          tests.forEach((test: any, index: number) => {
            this.selectedAppointments[index].exam.duration = test.duration;
          });
          this.selectedExamDetailService.setSelectedAppointmentDetails(this.selectedAppointments);
          this.schedulingError = result.error;
          observer.next(result.proctors);
          observer.complete();
        });
      this.proctorsSearched = true;
    });
  }

  /* Release hold and clears timer */

  releaseHold() {
    if (this.holdSlotObj && this.holdSlotObj.id) {
      this.schedulingApiService.releaseHold(this.holdSlotObj).subscribe((res) => {
        this.prevSelectedHoldObjArr = this.prevSelectedHoldObjArr.filter((slotObj: Hold) => {
          return this.holdSlotObj.slot.id != slotObj.slot.id
        });
        this.timerService.clearClock();
        this.selectedExamDetailService.setprevSelectedHoldObj(this.prevSelectedHoldObjArr);
      });
    }
  }

  /* Set selected slot so that user can hold it */
  setSelectedSlot(proctor: Proctor): void {

    this.releaseHold();

    this.selectedAppointments.forEach(
      (appt: AppointmentDetail, index: number) => {
        appt.appointmentSlot = new AppointmentSlot();
        appt.appointmentSlot.duration = this.selectedAppointments[index].exam.duration;
        appt.status = 'schedule';
      });

    //this.selectedAppointments[this.selectedIndex].appointmentSlot.site = siteSltObj;
    this.selectedAppointments[this.selectedIndex].hold = new Hold();
    this.selectedAppointments[this.selectedIndex].hold.slot = proctor;
    this.selectedAppointments[this.selectedIndex].appointmentSlot.startDateTime = new Date(this.utilityService.getFormatToFullMMDDYYYY(proctor.startDateTime, "/"));
    this.selectedAppointments[this.selectedIndex].appointmentSlot.duration = this.selectedAppointments[this.selectedIndex].exam.duration;
    this.selectedAppointments[this.selectedIndex].appointmentSlot.testEndTime = this.utilityService.getStartEndFormat(
      UtilityService.addMins(
        this.selectedAppointments[this.selectedIndex].appointmentSlot.startDateTime,
        this.selectedAppointments[this.selectedIndex].appointmentSlot.duration
      )
    );
    this.selectedAppointments[this.selectedIndex].appointmentSlot.testTime = this.utilityService.getTimeString(
      moment(this.selectedAppointments[this.selectedIndex].appointmentSlot.startDateTime).format("YYYY-MM-DDTHH:mm:ss"), this.selectedExamDetailService.timeFormat
    );
    this.holdSlotObj = new Hold();
    this.holdSlotObj.slot = proctor;
    this.selectedExamDetailService.setSlot(proctor);
    this.selectedProctor = proctor;

    this.selectedExamDetailService.setSelectedAppointmentDetails(this.selectedAppointments);

    this.isCurrentFormChanged = true;
    this.selectedSiteDetails.emit({
      selectedAppointments: this.selectedAppointments,
      holdSlotObj: this.holdSlotObj,
      selectedIndex: this.selectedIndex
    });
    this.slotsCheck.emit(true);

    if (this.selectedProctor == null || this.selectedProctor == undefined) {
      this.selectedSiteDetails.emit({});
    }
  }

  resetCurrentSelection(): void {
    this.selectedProctor = null;
    this.releaseHold();
    this.selectedAppointments.forEach((appt: AppointmentDetail) => {
      appt.appointmentSlot = new AppointmentSlot();
      appt.hold = new Hold();
    });
    this.slotsCheck.emit(false);
  }

  /* Show more sites based on default size */
  showMoreTimes() {
    $(".show-more-sites").addClass('no-outline');
    this.skipSiteSlotsize += this.takeProctorsize;
    this.selectedExamDetailService.setSkipSize(this.skipSiteSlotsize);

    this.getProctors().subscribe((procs: any) => {
      this.proctors = this.proctors.concat(procs);
      this.selectedExamDetailService.setProctors(this.proctors);
      // Show More Button should be disabled if there is no site in current call.
      if (procs.length == 0) {
        this.isMoreTimes = false;
      }
      this.addTimesAlert();
    });
  }


  //Adding a a one time per click alert to be read by a screenreader when more times are retrieved
  addTimesAlert() {
    if (this.isMoreTimes) {
      const timesAlert: HTMLElement = document.getElementById('moreTimesAlert');
      var div = document.createElement('div');
      var alertText = document.createTextNode("More time slots have been added to the list");
      div.appendChild(alertText);
      div.setAttribute('role', 'alert');
      timesAlert.append(div);

      setTimeout(() => {
        timesAlert.removeChild(div);
      }, 5000);
    }
  }

  togglePopover(event: any, currentPopUp: any): void {
    // TODO: Find best approach to fix this.
    let temp = this.utilityService.deepCompare(currentPopUp, this.selectedExamDetailService.prevSelectedPopoverObject);
    if (!temp && this.selectedExamDetailService.prevSelectedPopoverObject != undefined && this.selectedExamDetailService.prevSelectedPopoverObject != null) {
      this.selectedExamDetailService.prevSelectedPopoverObject.toggle();
    }
    else if (temp && this.selectedExamDetailService.prevSelectedPopoverObject != undefined
      && this.selectedExamDetailService.prevSelectedPopoverObject != null
      && event.target && event.target.className == "btn btn-success select") {
      this.selectedExamDetailService.prevSelectedPopoverObject.toggle();
    }

    this.selectedExamDetailService.prevSelectedPopoverObject = currentPopUp;
    this.selectedExamDetailService.outsidesClick = 1;
    if (!this.popoverEnabled) {
      this.popoverEnabled = true;
    } else {
      this.popoverEnabled = false;
    }
    $('.popover').hide();
    currentPopUp.toggle();

    // Change attribute default property from tooltip to dialog.
    // Task 333456:Ensure dialogs use proper structure
    let roleAttribute = document.createAttribute("role");
    roleAttribute.value = "dialog";

    let arialableAttribute = document.createAttribute("aria-label");
    arialableAttribute.value = "Update Testing Location";

    if ($(event.target).attr('id') != 'cancelPopup' &&
      !this.utilityService.isNullOrUndefined(currentPopUp.popover) ||
      (!this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextElementSibling) &&
        !this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextElementSibling.nextElementSibling))
      ||
      (!this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextSibling) &&
        !this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextSibling.nextSibling))
    ) {

      if ((!this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextElementSibling) &&
        !this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextElementSibling.nextElementSibling))) {
        currentPopUp.popover.elementRef.nativeElement.nextElementSibling.nextElementSibling.setAttributeNode(roleAttribute);
        currentPopUp.popover.elementRef.nativeElement.nextElementSibling.nextElementSibling.setAttributeNode(arialableAttribute);
      }
      else // Fix for I.E
      {
        currentPopUp.popover.elementRef.nativeElement.nextSibling.nextSibling.setAttributeNode(roleAttribute);
        currentPopUp.popover.elementRef.nativeElement.nextSibling.nextSibling.setAttributeNode(arialableAttribute);
      }
    }

    if ($(event.target).attr('id') == 'cancelPopup') {
      this.selectedExamDetailService.prevSelectedPopoverObject = null;
    }
    if (temp && this.selectedExamDetailService.prevSelectedPopoverObject != undefined
      && this.selectedExamDetailService.prevSelectedPopoverObject != null
      && event.target && event.target.className.indexOf("btn secNavAction") > -1) {
      this.selectedExamDetailService.prevSelectedPopoverObject = null;
      this.selectedExamDetailService.outsidesClick = 0;
    }
  }

  setSingleTimezone(timezone: Timezone) {
    if (timezone != null && timezone != undefined) {
      this.selectedTimezone = timezone;
    } else {
      this.selectedTimezone = null;
    }
  }

  /* Only display testing window if an eligibility was used or if it ends within a relevant amount of time */
  displayTestingWindow(): boolean {
    const toDate = new Date(this.overLapEndDate);
    return (!!this.eligibilityDetails
      && !!this.eligibilityDetails.length
      && !!this.eligibilityDetails[0]
      && !!this.eligibilityDetails[0].id)
      || (toDate.getFullYear() <= this.today.getFullYear() + this.bootstrapParams.testingWindowDisplayYears);
  }
}
